import type { Transition, Variants } from 'framer-motion'

/**
 * Shared motion language for the Capacitor shell.  Values intentionally use
 * springs instead of fixed-duration easing so interrupted gestures settle like
 * UIKit controls rather than replaying a CSS animation from the beginning.
 */
export const iosResponsiveSpring: Transition = {
  type: 'spring',
  stiffness: 430,
  damping: 38,
  mass: 0.78,
}

export const iosSheetSpring: Transition = {
  type: 'spring',
  stiffness: 390,
  damping: 36,
  mass: 0.86,
}

export const iosSelectionSpring: Transition = {
  type: 'spring',
  stiffness: 520,
  damping: 42,
  mass: 0.66,
}

export const iosBackdropTransition: Transition = {
  duration: 0.2,
  ease: [0.22, 1, 0.36, 1],
}

/**
 * Web surfaces should settle immediately and predictably.  Keep this separate
 * from the iOS spring so a browser never inherits a simulated native gesture.
 */
export const webSurfaceTransition: Transition = {
  duration: 0.18,
  ease: [0.2, 0.8, 0.2, 1],
}

export const iosPageVariants: Variants = {
  enter: (direction: number) => ({
    x: direction < 0 ? '-7%' : '9%',
    opacity: 0.62,
    scale: 0.992,
    filter: 'blur(3px)',
  }),
  center: {
    x: 0,
    opacity: 1,
    scale: 1,
    filter: 'blur(0px)',
  },
  exit: (direction: number) => ({
    x: direction < 0 ? '22%' : '-4%',
    opacity: direction < 0 ? 0.68 : 0.42,
    scale: direction < 0 ? 0.996 : 0.988,
    filter: 'blur(2px)',
  }),
}

/** Browser navigation stays a short, vertical surface transition rather than
 * imitating an iOS push gesture. */
export const webPageVariants: Variants = {
  enter: { y: 10, opacity: 0 },
  center: { y: 0, opacity: 1 },
  exit: { y: -6, opacity: 0 },
}

export const reducedPageVariants: Variants = {
  enter: { opacity: 0 },
  center: { opacity: 1 },
  exit: { opacity: 0 },
}

export function isNativeIOS() {
  return (
    typeof document !== 'undefined' &&
    document.documentElement.classList.contains('native-ios')
  )
}
